import {
  AnyAction,
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  StoreEnhancerStoreCreator,
} from 'redux';
import {
  createEpicMiddleware,
} from 'redux-observable';
import enhancer from './workerEnhancer';
import rootEpic from './workerEpic';
import reducers from './workerReducers';
import {
  IWorkerRootState,
} from './workerRootState';

const getConfiguredStore = () => {
  const epicMiddleware = createEpicMiddleware();

  let middlewares: Middleware[] = [epicMiddleware];
  if (process.env.NODE_ENV !== 'production') {
    middlewares = [...middlewares];
  }

  type OurStoreCreator = StoreEnhancerStoreCreator<IWorkerRootState>;

  const createdStore = createStore<IWorkerRootState, AnyAction, {}, {}>(
    reducers,
    compose<OurStoreCreator, OurStoreCreator, OurStoreCreator>(
      enhancer,
      (applyMiddleware as any)(...middlewares),
    ),
  );
  epicMiddleware.run(rootEpic);
  return createdStore;
};

export default getConfiguredStore;
